import React, { useEffect, useState } from "react";
import DTOComplaintARModal from "./DTOComplaintARModal";
import ComplaintARModalPresenter from "./ComplaintARModalPresenter";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import {
  setAllClaimList,
  setAllClaimListLoader,
} from "../../../../infra/aggregates/myProfile/claimAggregates/claimListSlice";
import { claimService } from "../../../../api/services/claimService";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import {
  setAllClaimHistory,
  setClaimTicketLoader,
} from "../../../../infra/aggregates/myProfile/claimAggregates/claimHistorySlice";
import { setAllAirTicketHistory } from "../../../../infra/aggregates/myProfile/claimAggregates/airTicketHistorySlice";
import { actionRequiredService } from "../../../../api/services/actionRequiredService";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  historyData?: any;
  fullData?: any;
}

const ComplaintARModalController = ({
  isModalOpen,
  closeModal,
  fullData,
  historyData,
}: ModalInterface) => {
  const selector = useAppSelector((state) => state.authSlice);
  const { t } = useTranslation();

  const [allActions, setAllActions] = useState([]);
  const getActions = (act: any) => {
    setAllActions(act);
  };

  const hitAction = (payload: any) => {
    actionRequiredService
      .finalActionSubmitActionRequired(payload)
      .then((res: any) => {
        if (res?.response == "success") {
          toast.success("Action Performed Successfully!");
          closeModal();
        }
      })
      .catch((err: any) => {
        toast.error(err?.response?.data?.data);
      });
  };
  return (
    <div>
      <DTOComplaintARModal setAllActions={getActions} />

      <ComplaintARModalPresenter
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        trans={t}
        historyData={historyData}
        fullData={fullData}
        allActions={allActions}
        handleSubmitAR_Request={hitAction}
        userId={selector.user_id}
      />
    </div>
  );
};

export default ComplaintARModalController;
